export default __webpack_public_path__ + "static/media/dan-rahmel@2x.99ba1463.png";